import { MenuItem } from "@mui/material";
import { useState } from "react";

import { getTranslateByKey } from "@/main/services/utils";
import WrapperModalCancelParts from "@/main/components/shared/boxCart/components/modalCancelParts/modalCancelParts";
import { RefreshQuoteByGetItemsType } from "../../boxCart/components/types";
import { CartState } from "@/main/store/cart";
import { useThreeDotsQuoteContext } from "../contex";

interface IThreeDotsQuoteCancelPartsProps {
	showButtonRemoveBulkPart: boolean;
	numbersParts: number;
	guidQuote: string;
	dataCart: CartState;
	isQuoteCanceled: boolean;
	refreshQuoteByGetItems: RefreshQuoteByGetItemsType;
}
function ThreeDotsQuoteCancelParts({
	showButtonRemoveBulkPart,
	numbersParts,
	guidQuote,
	dataCart,
	refreshQuoteByGetItems,
	isQuoteCanceled,
}: IThreeDotsQuoteCancelPartsProps) {
	const { closeThreeDotsQuote } = useThreeDotsQuoteContext();
	const [isOpenModalCancel, setIsOpenModalCancel] = useState<boolean>(false);

	function handleClickCancelParts() {
		setIsOpenModalCancel(true);
		closeThreeDotsQuote();
	}

	if (!showButtonRemoveBulkPart) return null;
	return (
		<>
			{!isQuoteCanceled && (
				<MenuItem id={`id-option-button-cancelParts`} onClick={handleClickCancelParts}>
					{getTranslateByKey("information.cancelParts")}
				</MenuItem>
			)}
			<WrapperModalCancelParts
				dataCart={dataCart}
				isOpenModal={isOpenModalCancel}
				numbersParts={numbersParts}
				guidQuote={guidQuote}
				refreshQuoteByGetItems={refreshQuoteByGetItems}
				setIsOpenModal={setIsOpenModalCancel}
				closeModal={() => setIsOpenModalCancel(false)}
			/>
		</>
	);
}

export { ThreeDotsQuoteCancelParts };
